export default "__VITE_ASSET__BNQjcLNi__"